import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderService } from '../../../shared/service/utils/loader.service';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: true,
    imports: [CommonModule],
})
export class LoaderComponent {
    isLoading$ = this.loaderService.loading$;
    text$ = this.loaderService.text$;

    constructor(public loaderService: LoaderService) {}
}
